import { ResolutionDetailPage } from '@/components/governance/resolution-detail-page'

export function MemberResolutionDetail() {
  return <ResolutionDetailPage basePath="/polls" />
}
